module.exports = __webpack_public_path__ + "static/gallery_peak_2_thumb-a84ddc53860ce47f8ea38f94dc650eeb.jpg";